module.exports = __webpack_public_path__ + "img/Car_roof.cb493538.svg";